module.exports = __webpack_public_path__ + "static/media/play_1.e5eb6167.mp3";